<!-- 作品管理/添加到专辑 -->
<template>
  <div class="works-profit">
    <cs-form label-width="90px" class="header-search-box padding-t-20" ref="validForm"
      form-width="100%"
      :form="searchParams"
      :formData="searchData"
      :inline="true">
      <template slot="sndCategory">
        <el-select v-model="searchParams.sndCategory" style="width:100%" multiple filterable clearable placeholder="请选择">
          <el-option
            v-for="item in sndCategoryList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template slot="updateTimeArr">
        <el-date-picker
          @change="formChange"
          v-model="updateTimeArr"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>
      <template slot="search">
        <el-button type="primary" @click="search">查 询</el-button>
      </template>
    </cs-form>
    <cs-table ref="multipleTable"
      :tableCols="tableCols"
      :tableData="tableData"
      class="no-shadow-table"
      :default-sort ="{prop:'updateTime',order:'descending'}"
      :paginationOption="paginationOption"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler"
      :show-overflow-tooltip="false"
      >
    </cs-table>
  </div>
</template>
<script>
import { fetchSndCategory } from '../../resource/api/index'
import { programSets, bindOrUnbind } from '@/resource/api/program-group-management'

export default {
  data () {
    return {
      searchParams: {
        name: '',
        category: '',
        sndCategory: '',
        startTime: '',
        endTime: '',
        pushState: '',
        limit: 20,
        offset: 1,
        operator: this.$store.state.router.createBy
      },
      baseDir: process.env.NODE_ENV === 'development' ? '/UGC' : '',
      updateTimeArr: [],
      tableCols: [
        { prop: 'name', label: '专辑名称', type: '' },
        { prop: 'category', label: '分类', type: '' },
        { prop: 'sndCategory', label: '二级分类', type: '' },
        { prop: 'updateTime', label: '更新时间', type: '', sortable: true },
        {
          prop: 'pushState',
          label: '状态',
          type: '',
          formatter: (row) =>
            row.pushState == 1 ? '已发布' : '未发布'
        },
        {
          prop: 'control',
          type: 'spbtn',
          label: '操作',
          width: 150,
          groups: [
            {
              isShow: () => true,
              title: '加入专辑',
              clickHandler: this.joinAlbum
            }
          ]
        }
      ],
      tableData: [],
      paginationOption: {},
      dialogData: {},
      categoryList: [],
      sndObj: {},
      sndCategoryList: [],
      multipleSelection: [],
      programIds: []
    }
  },
  mounted () {
    this.getCategoryList()
    this.getData()
    this.multipleSelection = this.$route.query.multipleSelection
    this.multipleSelection.forEach((item) => {
      this.programIds.push(item.id)
    })
  },
  methods: {
    // 获取分类下拉框内容
    async getCategoryList () {
      try {
        const res = await fetchSndCategory()
        if (res.code == 1) {
          const data = res.result
          data.forEach(item => {
            this.categoryList.push({
              value: item.category,
              label: item.category
            })
            this.sndObj[item.category] = []
            const arr = item.sndCategory
            arr.forEach((itemIn) => {
              this.sndObj[item.category].push({
                value: itemIn,
                label: itemIn
              })
            })
          })
        }
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    },
    // 获取二级分类
    selectChangeCategory (val) {
      this.searchParams.sndCategory = ''
      this.sndCategoryList = this.sndObj[val]
    },
    changeSnd () {
    },
    formChange (timeArr) {
      if (timeArr === null) {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      } else {
        this.searchParams.startTime = timeArr[0]
        this.searchParams.endTime = timeArr[1]
      }
    },
    async getData () {
      try {
        const res = await programSets({ ...this.searchParams })
        if (res.code == 1) {
          this.tableData = res.results
        }
        this.tableData.forEach((item, index) => {
          item.updateTime = this.$moment(item.updateTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.paginationOption = {
          'total': res.total,
          'page-size': this.searchParams.limit,
          'current-page': this.searchParams.offset
        }
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    },
    // 查询
    search () {
      this.searchParams.sndCategory = this.searchParams.sndCategory.toString().replace(',', ' ')
      this.currentPageHandler(1)
    },
    sizeChangeHandler (val) {
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.getData(this.searchParams)
    },
    currentPageHandler (val) {
      this.searchParams.offset = val
      this.getData(this.searchParams)
    },
    // 加入专辑
    joinAlbum (row) {
      const data = {
        bindOrUnbindFlag: '批量加入',
        programSetId: row.id,
        programIds: this.programIds,
        updateBy: this.$store.state.router.updateBy
      }
      this.$confirm(row.pushState == 1 ? '作品加入已经发布的专辑将自动发布且将不能修改，确定要加入该专辑?' : '确定要将所选节目加入该专辑吗?', '提示', {
        confirmButtonText: '加入',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await bindOrUnbind(data)
        if (res.code == 1) {
          this.$message({
            message: '加入成功',
            type: 'success'
          })
          this.$router.push({ path: `${this.baseDir}/programManagement` })
          // this.currentPageHandler(1)
        } else if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'error'
          })
          this.currentPageHandler(1)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消加入'
        })
      })
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'name',
          type: 'input',
          label: '专辑名称：',
          placeholder: '请输入专辑名称',
          clearable: true
        },
        {
          prop: 'category',
          label: '分类：',
          type: 'select',
          filterable: true,
          clearable: true,
          options: this.categoryList,
          change: this.selectChangeCategory
        },
        {
          prop: 'sndCategory',
          label: '二级分类：',
          multiple: true,
          filterable: true,
          clearable: true,
          type: 'slot'
        },
        { prop: 'updateTimeArr', type: 'slot', label: '更新时间' },
        // {
        //   prop: 'updateTime',
        //   label: '更新时间：',
        //   type: 'datetime',
        //   clearable: true,
        //   timeType: 'date',
        //   format: 'yyyy-MM-dd HH:mm:ss',
        //   valueFormat: 'yyyy-MM-dd HH:mm:ss'
        // },
        {
          prop: 'pushState',
          label: '状态：',
          type: 'select',
          placeholder: '请选择',
          filterable: true,
          clearable: true,
          options: [
            { label: '全部', value: '' },
            { label: '已发布', value: 1 },
            { label: '未发布', value: 0 }
          ]
        },
        { prop: 'search', type: 'slot', label: '' }
      ]
    }
  }
}
</script>
<style lang="less">
</style>
